/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";
import { labellessButtonCss } from "./styles";

const EditButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "common.edit" })}
      iconName="edit"
      css={labellessButtonCss}
      {...props}
      dataCy="edit-button"
    />
  );
};

export default EditButton;
